// Хук для глобальной настройки анимаций интерфейса.
//
// Источник истины — localStorage.corps.anim ('1' = включены, '0' = выключены).
// Этот ключ уже используется SettingsContent в ProfileScreen.tsx — мы его
// переиспользуем, чтобы тогл "Анимации" в настройках работал везде.
//
// События смены значения слушаем через storage-event (между вкладками) и
// через кастомный 'corps:anim-changed' (для текущей вкладки — тогл в
// настройках диспатчит его после localStorage.setItem).
//
// По умолчанию учитываем prefers-reduced-motion.

import { useState, useEffect } from 'react';

const LS_KEY = 'corps.anim';
const EVENT_NAME = 'corps:anim-changed';

function readCurrent(): boolean {
  try {
    const v = localStorage.getItem(LS_KEY);
    if (v === '1') return true;
    if (v === '0') return false;
  } catch { /* ignore */ }
  // По умолчанию ВКЛЮЧЕНО. prefers-reduced-motion НЕ используем как default —
  // Telegram WebView и Windows часто выставляют его без явного желания юзера,
  // что отключало анимацию непреднамеренно. Юзер сам решает в Settings.
  return true;
}

// Внешний API: вызвать из SettingsContent при тогле.
export function notifyAnimationsChanged() {
  try { window.dispatchEvent(new Event(EVENT_NAME)); } catch { /* ignore */ }
}

export function useAnimationsEnabled(): boolean {
  const [enabled, setEnabled] = useState<boolean>(() => readCurrent());
  useEffect(() => {
    const sync = () => setEnabled(readCurrent());
    const onStorage = (e: StorageEvent) => { if (e.key === LS_KEY) sync(); };
    window.addEventListener(EVENT_NAME, sync);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener('storage', onStorage);
    };
  }, []);
  return enabled;
}
